var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page-container"
  }, [_c('div', {
    attrs: {
      "id": "searchArea"
    }
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "fl pb10"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.addBtnLoading
    },
    on: {
      "click": function click($event) {
        return _vm.addOrUpdateHandle();
      }
    }
  }, [_vm._v("Add Campaign")])], 1), _c('div', {
    staticClass: "fr"
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.dataForm
    },
    nativeOn: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getDataList(1);
      }
    }
  }, [_c('el-form-item', [_c('el-input', {
    staticClass: "wd250",
    attrs: {
      "placeholder": "Title",
      "clearable": ""
    },
    model: {
      value: _vm.dataForm.title,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "title", $$v);
      },
      expression: "dataForm.title"
    }
  })], 1), _c('el-form-item', [_c('el-select', {
    staticClass: "wd200",
    attrs: {
      "clearable": "",
      "placeholder": "Status"
    },
    model: {
      value: _vm.dataForm.status,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "status", $$v);
      },
      expression: "dataForm.status"
    }
  }, _vm._l(_vm.campaignPushStatusList, function (item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.title,
        "value": item.value
      }
    });
  }), 1)], 1), _c('el-form-item', [_c('el-input', {
    staticClass: "wd300",
    attrs: {
      "placeholder": "Email / Client Code / Company Name",
      "clearable": ""
    },
    model: {
      value: _vm.dataForm.receiver,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "receiver", $$v);
      },
      expression: "dataForm.receiver"
    }
  })], 1), _c('el-form-item', [_c('el-button', {
    directives: [{
      name: "debounce",
      rawName: "v-debounce"
    }],
    attrs: {
      "icon": "el-icon-search",
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function click($event) {
        return _vm.getDataList(1);
      }
    }
  }, [_vm._v("Search")])], 1)], 1)], 1)])]), _c('div', [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.dataListLoading,
      expression: "dataListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "max-height": "640",
      "data": _vm.dataList,
      "default-sort": {
        prop: 'createTime',
        order: 'descending'
      }
    },
    on: {
      "sort-change": _vm.tableSortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "title",
      "align": "center",
      "label": "Title",
      "min-width": "150"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "template",
      "align": "center",
      "label": "Template",
      "min-width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        var _scope$row$template;

        return [_c('p', [_vm._v(_vm._s(((_scope$row$template = scope.row.template) === null || _scope$row$template === void 0 ? void 0 : _scope$row$template.title) || ""))])];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "Tags",
      "min-width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        var _scope$row$tags, _scope$row$tags$map;

        return [((_scope$row$tags = scope.row.tags) === null || _scope$row$tags === void 0 ? void 0 : _scope$row$tags.length) > 0 ? _c('p', [_vm._v(_vm._s((_scope$row$tags$map = scope.row.tags.map(function (i) {
          return i.tagName;
        })) === null || _scope$row$tags$map === void 0 ? void 0 : _scope$row$tags$map.join(", ")))]) : _vm._e()];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "prop": "sendType",
      "align": "center",
      "label": "Send Type",
      "width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c('p', [_vm._v(_vm._s(_vm.marketingEmailPushTypeFormat(scope.row.sendType)))])];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "prop": "scheduledTime",
      "align": "center",
      "label": "Scheduled Send Time",
      "width": "180"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "align": "center",
      "label": "Status",
      "width": "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c('p', [_vm._v(_vm._s(_vm.campaignPushStatusFormat(scope.row.status)))])];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "prop": "totalCount",
      "align": "center",
      "label": "Total Sent",
      "width": "130"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "failReason",
      "align": "center",
      "label": "Send Failure Reason",
      "min-width": "300"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "sendTime",
      "align": "center",
      "label": "Send Time",
      "width": "166"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "createTime",
      "align": "center",
      "label": "Create Time",
      "width": "166",
      "sortable": "custom"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "remark",
      "align": "center",
      "label": "Remark",
      "min-width": "260"
    }
  }), _c('el-table-column', {
    attrs: {
      "align": "center",
      "width": "150",
      "fixed": "right",
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.status == 'DRAFT' ? _c('el-button', {
          staticClass: "fwb",
          attrs: {
            "type": "text"
          },
          on: {
            "click": function click($event) {
              return _vm.addOrUpdateHandle(scope.row);
            }
          }
        }, [_vm._v("Edit")]) : _vm._e(), scope.row.status == 'DRAFT' ? _c('el-button', {
          staticClass: "fwb",
          attrs: {
            "type": "text"
          },
          on: {
            "click": function click($event) {
              return _vm.deleteHandle(scope.row);
            }
          }
        }, [_vm._v("Delete")]) : _vm._e(), ['SUCCESS', 'FAILED'].includes(scope.row.status) ? _c('el-button', {
          staticClass: "fwb",
          attrs: {
            "type": "text"
          },
          on: {
            "click": function click($event) {
              return _vm.receiveListHandle(scope.row);
            }
          }
        }, [_vm._v(" Receive List ")]) : _vm._e(), scope.row.sendType == 1 ? [scope.row.status == 'DRAFT' ? _c('el-button', {
          staticClass: "fwb",
          attrs: {
            "type": "text"
          },
          on: {
            "click": function click($event) {
              return _vm.sendHandle(scope.row);
            }
          }
        }, [_vm._v("Send Now")]) : _vm._e()] : _vm._e(), scope.row.sendType == 2 ? [scope.row.status == 'DRAFT' ? _c('el-button', {
          staticClass: "fwb",
          attrs: {
            "type": "text"
          },
          on: {
            "click": function click($event) {
              return _vm.sendHandle(scope.row);
            }
          }
        }, [_vm._v("Confirm Schedule")]) : _vm._e(), scope.row.status == 'PENDING' ? _c('el-button', {
          staticClass: "fwb",
          attrs: {
            "type": "text"
          },
          on: {
            "click": function click($event) {
              return _vm.cancelScheduleHandle(scope.row);
            }
          }
        }, [_vm._v("Cancel Schedule")]) : _vm._e()] : _vm._e()];
      }
    }])
  })], 1)], 1), _c('pagination', {
    attrs: {
      "current": _vm.current,
      "pageSize": _vm.pageSize,
      "totalCount": _vm.totalCount
    },
    on: {
      "size-change": _vm.sizeChangeHandle,
      "current-change": _vm.currentChangeHandle
    }
  }), _c('add-or-update', {
    ref: "addOrUpdate",
    attrs: {
      "tagInfoList": _vm.tagInfoList,
      "templateList": _vm.templateList
    },
    on: {
      "refreshDataList": _vm.getDataList
    }
  }), _c('receive-list', {
    ref: "receiveList"
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }